import React, { Component } from 'react';

export class StepPage extends Component {

    constructor(props) {
        super(props);
    }

    validate() {
        //
        return { state: false, msg: "Should override this funtion validate in heritage class" };
    }
}
